import React from "react";
import { TRUST_BAR } from "@/data/landing";
import { ShieldCheck } from "lucide-react";

export default function TrustBar() {
  return (
    <section className="bg-black border-y border-white/10" data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {TRUST_BAR.map((t, i) => (
          <div key={i} className="flex items-start gap-2" data-testid={`trust-item-${i}`}>
            <ShieldCheck size={15} className="text-[#e63946] mt-0.5 flex-shrink-0" />
            <span className="text-[11px] md:text-xs font-mono uppercase tracking-[0.12em] text-zinc-300 leading-tight">
              {t}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
